// Подсказки города ничего не дали (или сервер не ответил): одна строка
// вместо посторонних городов — в полях города программ (CityAutocomplete),
// в кабинете и в форме натальной карты на главной.
export const CITY_NOT_FOUND_TEXT = 'Город не нашёлся. Проверь написание или выбери ближайший крупный город.';
